import Svg from '@app/components/svg';

const Fragment = () => (
  <>
    <path
      d="M19.5 13.5H53.5C54.8807 13.5 56 14.6193 56 16V59C56 60.3807 54.8807 61.5 53.5 61.5H19.5C18.1193 61.5 17 60.3807 17 59V16C17 14.6193 18.1193 13.5 19.5 13.5Z"
      fill="white"
      stroke="#013A4C"
      strokeWidth="3"
    />
    <path
      d="M23.5 37H41.5"
      stroke="#587A85"
      strokeWidth="3"
      strokeLinecap="round"
    />
    <path
      d="M23.5 45H26.5"
      stroke="#587A85"
      strokeWidth="3"
      strokeLinecap="round"
    />
    <path
      d="M31.5 45H45.5"
      stroke="#587A85"
      strokeWidth="3"
      strokeLinecap="round"
    />
    <path
      d="M23.5 29H35.5"
      stroke="#587A85"
      strokeWidth="3"
      strokeLinecap="round"
    />
    <path
      d="M40.5 29H48.5"
      stroke="#587A85"
      strokeWidth="3"
      strokeLinecap="round"
    />
    <path
      d="M23.5 21H28.5"
      stroke="#013A4C"
      strokeWidth="3"
      strokeLinecap="round"
    />
    <path
      d="M62.5 5H45.5C41.0817 5 37.5 8.58172 37.5 13C37.5 17.4183 41.0817 21 45.5 21H62.5C66.9183 21 70.5 17.4183 70.5 13C70.5 8.58172 66.9183 5 62.5 5Z"
      fill="#F2DCE4"
    />
    <path
      d="M58.5 10H63.5"
      stroke="#013A4C"
      strokeWidth="3"
      strokeLinecap="round"
    />
    <path
      d="M53.5 16H63.5"
      stroke="#013A4C"
      strokeWidth="3"
      strokeLinecap="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M53.7857 9.42857L52.875 7L51.9643 9.42857L50.25 10L51.9643 10.5714L52.875 13L53.7857 10.5714L55.5 10L53.7857 9.42857ZM46.8446 12.6149L45.375 8.5L43.9054 12.6149L40.5 13.75L43.9054 14.8851L45.375 19L46.8446 14.8851L50.25 13.75L46.8446 12.6149Z"
      fill="#013A4C"
    />
    <path
      d="M62.5 24H45.5C41.0817 24 37.5 27.5817 37.5 32C37.5 36.4183 41.0817 40 45.5 40H62.5C66.9183 40 70.5 36.4183 70.5 32C70.5 27.5817 66.9183 24 62.5 24Z"
      fill="#F2DCE4"
    />
    <path
      d="M59.5 29H64.5"
      stroke="#013A4C"
      strokeWidth="3"
      strokeLinecap="round"
    />
    <path
      d="M60.5 35H64.5"
      stroke="#013A4C"
      strokeWidth="3"
      strokeLinecap="round"
    />
    <path
      d="M52.5 35H55.5"
      stroke="#013A4C"
      strokeWidth="3"
      strokeLinecap="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M53.7857 28.4286L52.875 26L51.9643 28.4286L50.25 29L51.9643 29.5714L52.875 32L53.7857 29.5714L55.5 29L53.7857 28.4286ZM46.8446 31.6149L45.375 27.5L43.9054 31.6149L40.5 32.75L43.9054 33.8851L45.375 38L46.8446 33.8851L50.25 32.75L46.8446 31.6149Z"
      fill="#013A4C"
    />
    <path
      d="M37.5 55C37.5 45.6112 29.8888 38 20.5 38C11.1112 38 3.5 45.6112 3.5 55C3.5 64.3888 11.1112 72 20.5 72C29.8888 72 37.5 64.3888 37.5 55Z"
      fill="#F2F6F8"
    />
    <path
      d="M11.125 59.8594V62.2031C11.125 62.8247 11.3719 63.4209 11.8115 63.8604C12.251 64.2999 12.8471 64.5469 13.4688 64.5469H27.5312C28.1529 64.5469 28.749 64.2999 29.1885 63.8604C29.6281 63.4209 29.875 62.8247 29.875 62.2031V59.8594"
      stroke="#013A4C"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.6406 50.4844L20.5 44.625L26.3594 50.4844"
      stroke="#013A4C"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.5 44.625V58.6875"
      stroke="#013A4C"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
);

const AiExtractIcon = Svg(Fragment, {
  viewBox: '0 0 76 75',
  fill: 'none',
});

AiExtractIcon.displayName = 'AiExtractIcon';

export default AiExtractIcon;
